// Production domain — .env dosyasında REACT_APP_SITE_URL set et
export const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://YOUR_DOMAIN';
export const SITE_NAME = 'Adisyon Takip';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/logo512.png`;
